import { IconHeadset, IconShieldCheck, IconTag, IconWorld } from "@tabler/icons-react";
import PaddedView from "src/components/UI/PaddedView/PaddedView";
import { useLocaleContext } from "src/context/locale-context";
import classes from "./DesktopBenefitsStrip.module.css";
import { getBenefitsText } from "./benefitsText";

const ITEMS = [
  { icon: IconShieldCheck, titleKey: "home.benefits.trust.title", descKey: "home.benefits.trust.desc" },
  { icon: IconTag, titleKey: "home.benefits.prices.title", descKey: "home.benefits.prices.desc" },
  { icon: IconHeadset, titleKey: "home.benefits.support.title", descKey: "home.benefits.support.desc" },
  { icon: IconWorld, titleKey: "home.benefits.destinations.title", descKey: "home.benefits.destinations.desc" },
];

export function DesktopBenefitsStrip() {
  const { getStringRes } = useLocaleContext();

  return (
    <div className={classes.strip}>
      <PaddedView>
        <div className={classes.grid}>
          {ITEMS.map(({ icon: Icon, titleKey, descKey }) => (
            <div key={titleKey} className={classes.item}>
              <div className={classes.iconWrap}>
                <Icon size={22} stroke={1.75} />
              </div>
              <div>
                <p className={classes.itemTitle}>{getBenefitsText(getStringRes, titleKey)}</p>
                <p className={classes.itemDesc}>{getBenefitsText(getStringRes, descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </PaddedView>
    </div>
  );
}
